import { render, staticRenderFns } from "./AccountCobine.vue?vue&type=template&id=60a1ccc2&"
import script from "./AccountCobine.vue?vue&type=script&lang=js&"
export * from "./AccountCobine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports